import * as React from 'react';
import { Route, Redirect, useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';

const AuthRoute = props => {
  const history = useHistory();
  // console.log(history);
  const { component: Component, ...rest } = props;
  return (
    <Route
      {...rest}
      render={routeProps =>
        localStorage.getItem('isUserLogged') ? (
          <Component {...routeProps} />
        ) : (
          <>
            {localStorage.setItem('redirection', history.location.pathname)}
            <Redirect
              to={{
                pathname: '/login',
              }}
            />
          </>
        )
      }
    />
  );
};

AuthRoute.propTypes = {
  component: PropTypes.elementType.isRequired,
};

export default AuthRoute;
